<template>
  <lDfault :title="title">
    <main class="mg-t sign-up">
      <div
        v-if="way === 'signup' && registerSwitchReady && !registerEnabled"
        class="reg-disabled-notice"
      >
        <van-icon name="info-o" size="48" color="#ff976a" />
        <p class="notice-title">注册功能暂时关闭</p>
        <p class="notice-desc">{{ registerDisabledMsg }}</p>
      </div>
      <van-form
        v-else-if="way !== 'signup' || (registerSwitchReady && registerEnabled)"
        validate-first
      >
        <van-field
          v-model="passwd"
          :type="passwdEye ? 'password' : 'text'"
          :right-icon="passwdEye ? 'closed-eye' : 'eye-o'"
          label="密码"
          placeholder="请输入密码"
          @click-right-icon="onChangeType('passwd')"
        />
        <van-button class="submit" type="primary" @click="onSubmit" block>{{
          buttonText
        }}</van-button>
      </van-form>
    </main>
  </lDfault>
</template>

<script>
// @ is an alias to /src
import { updatePwd, registerPhone } from "@/api";
import lDfault from "@/templates/Default.vue";
import behaviorTracker from "@/mixins/behaviorTracker";
import registerSwitch from "@/mixins/registerSwitch";
import * as bt from "@/utils/behaviorTracker";
// import icon from "@/components/Icon.vue";
export default {
  mixins: [behaviorTracker, registerSwitch],
  __behaviorStep: "set_password",
  components: {
    lDfault,
  },
  // props: { code: String, way: String },
  data() {
    return {
code:'',way:'',


      passwd: "",
      passwdEye: true,
      title: "",
      buttonText: "",
    };
  },
  mounted() {
    const verify=JSON.parse(sessionStorage.getItem('verify'))
    this.way=verify.way
    this.code=sessionStorage.getItem('code')

    if (this.way === "signup") {
      this.title = "快速注冊";
      this.buttonText = "快速注册";
    } else {
      this.title = "找回密码";
      this.buttonText = "找回密码";
    }
  },
  methods: {
    onSubmit() {
      if (this.passwd.length < 6) {
        this.$toast("请输入六位以上字母与数字");
        return;
      }
      if (this.way === "signup") {
        if (!this.registerEnabled) {
          this.$toast(this.registerDisabledMsg);
          return;
        }
        registerPhone({
          phone: this.$route.params.phone,
          passwd: this.passwd,
          randomNum: this.code,
          bsc:localStorage.getItem('bsc'),
          behavior: bt.getPayload(),
        }).then((res) => {
          console.log(res);
          if (res.status) {
            bt.reset();
            this.$toast("注册成功!");
            this.$router.replace({ name: "My" });
          } else {
            this.$toast(res.msg);
          }
        });
      } else {
        updatePwd({
          code: this.code,
          phone: this.$route.params.phone,
          password: this.passwd,
        }).then((res) => {
          if (res) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast("修改失败");
          }
        });
      }
    },
    onChangeType(type) {
      if (type === "passwd") {
        this.passwdEye = !this.passwdEye;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sign-up {
  padding: 0 30px;
  .submit {
    margin-top: 20px;
  }
  .reg-disabled-notice {
    text-align: center;
    padding: 60px 20px;
    .notice-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 16px 0 8px;
    }
    .notice-desc {
      font-size: 14px;
      color: #999;
      line-height: 1.6;
    }
  }
}
</style>
